import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-users-search',
		path: '/dashboard/users/search',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin_users_search" */ './index'), {
			exportName: 'AdminUsersSearch',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: ['product', 'campaigns', 'support'],
		},
		frame: true,
		ssr: {
			// switch this to true to enable SSR
			enabled: false,
			seo: false,
		},
	},
];
